// These values match the ones we receive from the package's nav node
export const FLYERS_KEY = 'flyers';
export const CARDS_KEY = 'cards';

export const navNodeHasCrossSelling = (
  mobileFlyerCategories,
  desktopFlyerCategories,
  isMobile,
) => {
  const flyerCategories = isMobile
    ? mobileFlyerCategories
    : desktopFlyerCategories;
  return !!flyerCategories.length;
};

export const getDefaultCrossSellingTab = (
  isMobile,
  mobileDefaultCrossSellingTab,
  desktopDefaultCrossSellingTab,
) => {
  return isMobile
    ? mobileDefaultCrossSellingTab
    : desktopDefaultCrossSellingTab;
};

export const getActiveTabKey = (
  tabQueryValue,
  isMobile,
  mobileDefaultCrossSellingTab,
  desktopDefaultCrossSellingTab,
) => {
  return tabQueryValue &&
    (tabQueryValue === FLYERS_KEY || tabQueryValue === CARDS_KEY)
    ? tabQueryValue
    : getDefaultCrossSellingTab(
        isMobile,
        mobileDefaultCrossSellingTab,
        desktopDefaultCrossSellingTab,
      );
};
